export default __webpack_public_path__ + "static/media/AvenirNext-DemiBold.c9b2b0e2.woff2";